import React from "react";
import PropTypes from "prop-types";
import Typeahead from "../BaseControls/Typeahead/Typeahead";
import ControlTemplate from "../BaseControls/ControlTemplate";
import { controlPropTypes } from "../formhelpers";

export default class ChoiceTypeahead extends React.Component {
    render() {
        const {descriptor, value, options, columns, valueKey, labelKey} = this.props;
        const config = descriptor.config || {options: []};
        return (
            <ControlTemplate {...this.props} className="choice-field" extraProps={{style: {display: "block"}}} >
                <Typeahead
                    {...this.props}
                    value={value}
                    options={options || config.options}
                    columns={columns || config.columns}
                    valueKey={valueKey || config.valueKey}
                    labelKey={labelKey || config.labelKey}
                    multiValued={config.multiValued}
                    mode={config.mode}
                    addMissing={config.autoSelectFirstItem !== undefined ? config.autoSelectFirstItem : !config.multiValued }
                    statusMessage={config.statusMessage}
                    showRecordBrowserIcon={config.showRecordBrowserIcon}
                    showSelectAll={config.showSelectAll}
                    autoSelectFirstItem={config.autoSelectFirstItem}
                    autoSelectOnlyOption={config.autoSelectOnlyOption}
                    keepSelectionInList={config.keepSelectionInList !== undefined ? config.keepSelectionInList : !config.multiValued}
                />
            </ControlTemplate>
        );
    }
}

ChoiceTypeahead.propTypes = {
    ...controlPropTypes({
        options: PropTypes.arrayOf(PropTypes.object),
        columns: PropTypes.arrayOf(PropTypes.shape({
            includeInFilter: PropTypes.bool,
            isSortable: PropTypes.bool,
            key: PropTypes.string.isRequired,
            label: PropTypes.string.isRequired,
        })),
        multiValued: PropTypes.bool.isRequired,
        mode: PropTypes.oneOf(["client","server"]),
        otherEntityKey: PropTypes.string,
        valueKey: PropTypes.string,
        labelKey: PropTypes.string,
        addMissing: PropTypes.bool,
        showRecordBrowserIcon: PropTypes.bool,
        showSelectAll: PropTypes.bool,
        autoSelectFirstItem: PropTypes.bool,
        autoSelectOnlyOption: PropTypes.bool,

        // TODO: This seems like a propsResolver concern. It was used to listen
        // and update the control on "RECORD" changes.
        otherEntityType: PropTypes.string,
    }),

    // Value is assumed to be the inflated value(s) or null. Meaning an object
    // with {[valueKey]: ... , [labelKey]: ... } or array of those objects.
    // This is different from how the jQuery control worked which only supplied
    // the value string(s) and expected the inflated value to exist in the
    // options list.
    value: PropTypes.oneOfType([PropTypes.object,PropTypes.arrayOf(PropTypes.object)]),

    onRecordbrowserClick: PropTypes.func,
    onSearch: PropTypes.func,
    valueKey: PropTypes.string,
    labelKey: PropTypes.string,
};



// WEBPACK FOOTER //
// ./app/lib/common/descriptorcontrols/ChoiceField/typeahead.js